import axios from 'axios';
import { Message, Loading } from 'element-ui';
import {
  requestUse,
  responseUse,
  generatorApi,
} from './apiInterceptors';
// import { DRCNET_BASE_URL } from '../config';
import { getUserToken, loginOut } from '../utils';

let loadingInstance;


const drcnet = axios.create({
  // baseURL: DRCNET_BASE_URL,
  expendConfig: 0,
  // validateStatus: status => status < 500,
});


const options = {
  header: () => getUserToken(),
  loading: (flag) => {
    if (flag) {
      loadingInstance = Loading.service({
        background: 'rgba(255,255,255,0.8)',
      });
    } else if (loadingInstance) {
      loadingInstance.close();
      // const body = document.getElementsByTagName('body')[0].style;
      // body.overflow = 'auto';
      // body.paddingRight = 0;
    }
  },
  messageError: (msg) => {
    Message.error(msg || '请求失败');
  },
  message: (msg) => {
    Message.error(msg);
  },
  signOut: () => {
    loginOut({}, 'home');
  },
  noRoot: () => {
    Message.error('权限不足，请联系平台管理员开通');
  },
};

const responseUseErr = (error) => {
  if (loadingInstance) {
    loadingInstance.close();
  }
  if (error.message) {
    Message.error(error.message);
  } else {
    Message.error('服务器异常，请稍候再试');
  }
  console.log('请求失败', error);
  return Promise.reject(error);
};


const requestUseAdmin = request => requestUse(request, options);
const responseUseAdmin = response => responseUse(response, options);

drcnet.interceptors.request.use(requestUseAdmin);
drcnet.interceptors.response.use(responseUseAdmin, responseUseErr);


export default generatorApi(drcnet);
